import { Colors } from "../../config/DesignConstants";
import { V2d } from "../../core/Vector";
import { LevelEntity } from "../LevelEntity";
import { TextAnchor, VectorText } from "../text/VectorText";

const DURATION = 3;
const FADE_OUT_DURATION = 1;

export class LevelIntro extends LevelEntity {
  private levelText: VectorText;

  constructor(levelNumber: number) {
    super();

    // Text will be set in onAdd when we have access to the current level
    this.levelText = this.addChild(
      new VectorText({
        text: `LEVEL ${levelNumber}`,
        scale: 4,
        color: Colors.CYAN,
        strokeWidth: 3,
        anchor: TextAnchor.CENTER,
        layer: "ui",
      }),
    );
  }

  async onAdd() {
    await this.wait(DURATION);
    await this.waitRender(FADE_OUT_DURATION, (dt, t) => {
      this.levelText.textSprite.alpha = 1 - t;
    });
    await this.wait(); // one more frame to ensure the text is fully faded out
    this.destroy();
  }

  onRender() {
    const viewportSize = this.game!.camera.getViewportSize();
    const centerX = viewportSize.x / 2;
    const upperY = viewportSize.y * 0.25;
    this.levelText.position = new V2d(centerX, upperY);
  }
}
